import { errorMsg } from '../../utils/errorMsg';
import React, { useState, useEffect } from 'react';
import {
  Container, Typography, Box, Button, TextField, FormControl, InputLabel,
  Select, MenuItem, CircularProgress, Alert, Paper, Grid
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SaveIcon from '@mui/icons-material/Save';
import { useNavigate } from 'react-router-dom';
import { criarDiscipulado, atualizarDiscipulado, getDiscipulado } from '../../api/discipulado';
import api from '../../axios';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import ContextNavBar from '../../components/ContextNavBar';
import ModuleHeader from '../../components/ModuleHeader';

const STATUS_OPCOES = [
  { value: 'ativo', label: 'Ativo' },
  { value: 'pausado', label: 'Pausado' },
  { value: 'concluido', label: 'Concluído' },
  { value: 'cancelado', label: 'Cancelado' }
];

function DiscipuladoForm() {
  const navigate = useNavigate();
  const [membros, setMembros] = useState([]);
  const [membrosSemDisc, setMembrosSemDisc] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [erro, setErro] = useState('');
  const [form, setForm] = useState({
    discipulador_id: '',
    discipulando_id: '',
    status: 'ativo',
    data_inicio: new Date().toISOString().split('T')[0],
    observacoes: ''
  });

  useEffect(() => {
    setLoading(true);
    Promise.all([
      api.get('/secretaria/membros'),
      api.get('/discipulados/sem-discipulador').catch(() => []),
    ])
      .then(([membrosRes, semDiscRes]) => {
        setMembros(membrosRes.data || []);
        setMembrosSemDisc(semDiscRes.data || semDiscRes || []);
      })
      .catch((err) => {
        setErro(errorMsg(err) || 'Erro ao carregar membros');
      })
      .finally(() => setLoading(false));
  }, []);

  const handleChange = (field) => (e) => {
    setForm(f => ({ ...f, [field]: e.target.value }));
  };

  const handleSalvar = async () => {
    if (!form.discipulador_id) { setErro('Selecione o discipulador.'); return; }
    if (!form.discipulando_id) { setErro('Selecione o discipulando.'); return; }
    setSaving(true);
    setErro('');
    try {
      const payload = {
        ...form,
        discipulador_id: parseInt(form.discipulador_id, 10),
        discipulando_id: parseInt(form.discipulando_id, 10),
        data_inicio: form.data_inicio || undefined,
      };
      await criarDiscipulado(payload);
      navigate('/discipulados');
    } catch (err) {
      setErro(errorMsg(err) || 'Erro ao salvar discipulado');
    }
    setSaving(false);
  };

  if (loading) {
    return (
      <>
        <Header />
        <ContextNavBar context="discipulado" />
        <Container maxWidth="md" sx={{ py: { xs: 2, md: 4 }, px: { xs: 1, md: 2 } }}>
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}><CircularProgress /></Box>
        </Container>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />
      <ContextNavBar context="discipulado" />
      <Container maxWidth="md" sx={{ py: { xs: 2, md: 4 }, px: { xs: 1, md: 2 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
          <Button startIcon={<ArrowBackIcon />} onClick={() => navigate('/discipulados')} size="small">Voltar</Button>
        </Box>
        <Typography variant="h4" sx={{ fontWeight: 800, mb: 3, fontSize: { xs: '1.2rem', md: '1.5rem' } }}>Novo Discipulado</Typography>

        <Paper sx={{ p: 3, borderRadius: 2 }} elevation={2}>
          {erro && <Alert severity="error" sx={{ mb: 2 }}>{erro}</Alert>}

          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Discipulador *</InputLabel>
                <Select value={form.discipulador_id} label="Discipulador *" onChange={handleChange('discipulador_id')}>
                  <MenuItem value="">Selecione</MenuItem>
                  {membros.map(m => (
                    <MenuItem key={m.id} value={m.id}>{m.nome}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Discipulando *</InputLabel>
                <Select value={form.discipulando_id} label="Discipulando *" onChange={handleChange('discipulando_id')}>
                  <MenuItem value="">Selecione</MenuItem>
                  {(membrosSemDisc.length > 0 ? membrosSemDisc : membros).map(m => (
                    <MenuItem key={m.id} value={m.id}>{m.nome}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Status</InputLabel>
                <Select value={form.status} label="Status" onChange={handleChange('status')}>
                  {STATUS_OPCOES.map(o => (
                    <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField label="Data de Início" type="date" value={form.data_inicio} onChange={handleChange('data_inicio')} fullWidth InputLabelProps={{ shrink: true }} />
            </Grid>
            <Grid item xs={12}>
              <TextField label="Observações" value={form.observacoes} onChange={handleChange('observacoes')} fullWidth multiline rows={3} />
            </Grid>
          </Grid>

          <Box sx={{ display: 'flex', gap: 2, mt: 3, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
            <Button variant="outlined" onClick={() => navigate('/discipulados')}>Cancelar</Button>
            <Button variant="contained" startIcon={<SaveIcon />} onClick={handleSalvar} disabled={saving}>
              {saving ? <CircularProgress size={20} /> : 'Salvar'}
            </Button>
          </Box>
        </Paper>
      </Container>
      <Footer />
    </>
  );
}

export default DiscipuladoForm;
